// auth.selectors.ts
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.model';

// Selector to get the entire AuthState
export const getAuthState = createFeatureSelector<AuthState>('auth');

// Selector to get the current user
export const getCurrentUser = createSelector(
  getAuthState,
  (state: AuthState) => state.currentUser
);

// Selector to get the user role (assuming roles is an array)
export const getUserRole = createSelector(
  getCurrentUser,
  (currentUser) => currentUser?.roles?.[0]?.role_name || null // Get the first role's name
);

// Selector to get the user permissions (assuming permissions is an array in the role)
export const getUserPermissions = createSelector(
  getCurrentUser,
  (currentUser) =>
    currentUser
      ? currentUser.roles?.[0]?.permissions ?? []
      : null
);

export const getAuthInitialized = createSelector(
  getAuthState,
  (state: AuthState) => state.initialized
);